import { mount } from '../dom-lifecycle';

// Live "N/MAX znaków" counter, rendered bottom-right under any <textarea data-counter="MAX">.
mount('textarea[data-counter]', function (el) {
    const max = parseInt(el.dataset.counter, 10);
    const counter = document.createElement('div');
    counter.className = 'textarea-counter';

    const update = () => { counter.textContent = `${el.value.length}/${max} znaków`; };

    el.after(counter);
    update();
    el.addEventListener('input', update);
});
